export default __webpack_public_path__ + "static/media/accommodations4_668.ec0e4699.webp";